import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-10 text-2xl" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "text-center" }, "Editors and Contributors", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Michael Marx (editor in chief)", -1)
const _hoisted_4 = { class: "list-disc pl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", null, " Variant readings of the Qurʾān (qirāʾāt) are listed for Q " + _toDisplayString(_ctx.$route.params.sura) + ":" + _toDisplayString(_ctx.$route.params.verse) + " in Latin transcription from the following sources: ", 1),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contributions, (c) => {
        return (_openBlock(), _createElementBlock("li", {
          key: c.source
        }, _toDisplayString(c.source) + " " + _toDisplayString(_ctx.contributorsString(c.contributors)), 1))
      }), 128))
    ])
  ]))
}